import { createStore } from "vuex";
import axios from "axios";

import CompanyModule from "./modules/company";
import IndexModule from "./modules/index";

export const store = createStore({
  modules: {
    index: IndexModule,
    company: CompanyModule,
  },
});

if (store.getters.isAuthenticated) {
  const currentCompanyId = store.getters["company/currentCompanyId"];
  axios.defaults.headers.common["BiBook-Company-Id"] = currentCompanyId;
  axios.defaults.headers.common["FinanceRocks-Locale"] =
    store.getters["language"];
  if (currentCompanyId !== null) {
    store.dispatch("company/fetchCompany");
  }
}

export default store;
